import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';

import {
  IAdvancedFormEvent, IAdvancedFormConfig, AdvancedFormEventTypes
} from '~shared/modules/advanced-form/models/advanced-form.model';
import { BadRequestHttpError } from '~shared/modules/error-handler';

import { AccountManagementDataService } from '../../services/account-management-data.service';
import { AccountManagementService } from '../../services/account-management.service';
import { IChangeEmailData } from '../../models/account-info.model';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
})
export class ChangeEmailComponent implements OnInit {
  public advancedFormConfig$: Observable<IAdvancedFormConfig>;

  constructor(
    private accountManagementDataService: AccountManagementDataService,
    private accountManagementService: AccountManagementService,
  ) { }

  public ngOnInit(): void {
    this.advancedFormConfig$ = this.accountManagementDataService.getAdvancedFormConfigForChangeEmail();
  }

  public onAdvancedFormEvents(event: IAdvancedFormEvent): void {
    if (event.type === AdvancedFormEventTypes.submit) {
      const changeEmailData = event.payload.formData as IChangeEmailData;
      this.accountManagementService.changeEmail(changeEmailData).pipe(
        take(1)
      ).subscribe(
        () => event.done(),
        (error: BadRequestHttpError) => event.done(
          this.transformInvalidParams(error.invalidParams)
        ),
      );
    }
  }

  private transformInvalidParams(invalidParams: { [key: string]: any }) {
    const { email, password, ...transformedInvalidParams } = invalidParams;

    if (email) {
      transformedInvalidParams.newEmail = email;
    }

    if (password) {
      transformedInvalidParams.confirmationPassword = password;
    }

    return transformedInvalidParams;
  }
}
